<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="系列" prop="seriesId">
      <goods-series-website-select v-model="form.data.seriesId"/>
    </a-form-model-item>
    <a-form-model-item label="名称" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="编码" prop="code">
      <a-input v-model="form.data.code"/>
    </a-form-model-item>
    <a-form-model-item label="图片(220*220)" prop="coverPath">
      <div class="a-input">
        <cropper-uploader
            v-model="form.data.coverPath"
            :imageUrl="form.data.coverPath"
            :options="coverOptions"
            avatarTextTop=""
            avatarTextBottom=""/>
      </div>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!goodsCategoryId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="goodsCategoryId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _addGoodsCategory,
  _queryGoodsCategories,
  _queryGoodsCategory,
  _updateGoodsCategory,
} from '@/api/websiteGoodsCategoryApi';
import GoodsSeriesWebsiteSelect from '@/components/contentSelector/GoodsSeriesWebsiteSelect.vue';
import CropperUploader from '@/components/CropperUploader.vue';

function treeGenerator(x, data, ignoreId) {
  const children = data.filter(child => child.value !== ignoreId && child.parentId === x.value && child.hbxLevel !== '3').map(child => treeGenerator(child, data));
  return {
    ...x,
    children,
  };
}

// 数据格式化
function formatData(data) {
  data.forEach((element) => {
    if (element.children && element.children.length > 0) {
      this.formatData(element.children);
    } else {
      element.children = undefined;
    }
  });
  return data;
}

async function getGoodsCategoryList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsCategories({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  if (result) {
    const categoryData = result.content.map(x => ({
      value: x.id,
      label: x.name,
      parentId: x.parentId,
    }));
    this.category.tree = [
      {
        value: null,
        label: '根节点',
        children: categoryData.filter(x => !x.parentId && x.value !== this.goodsCategoryId).map(x => treeGenerator(x, categoryData, this.goodsCategoryId)),
      },
    ];
    this.category.tree = this.formatData(this.category.tree);
  }
  if (this.goodsCategoryId) {
    await this.getGoodsCategory();
  }
}

async function getGoodsCategory() {
  const result = await _queryGoodsCategory(this.goodsCategoryId);
  console.log(result);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.nameEn = result.nameEn;
    this.form.data.parentId = result.parentId;
    this.form.data.coverPath = result.coverPath;
    this.form.data.code = result.code;
    this.form.data.seriesId = result.seriesId;
    this.form.data.isVip = result.isVip;
    this.form.data.isPush = result.isPush;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsCategory({
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        parentId: this.form.data.parentId,
        coverPath: this.form.data.coverPath,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        isVip: this.form.data.isVip,
        isPush: this.form.data.isPush,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsCategory(this.goodsCategoryId, {
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        parentId: this.form.data.parentId,
        coverPath: this.form.data.coverPath,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        isVip: this.form.data.isVip,
        isPush: this.form.data.isPush,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'WebsiteGoodsCategoryEdit',
  components: {
    CropperUploader,
    // SimpleUploader,
    GoodsSeriesWebsiteSelect,
    // DictSelect,
  },
  props: {
    goodsCategoryId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {

    goodsCategoryId() {
      if (this.goodsCategoryId) {
        this.getGoodsCategory();
      }
    },
    cascaderProps(val) {
      this.form.data.parentId = val[val.length - 1];
    },
    'form.data.type'(newVal, oldVal) {
      this.cascaderProps = [];
      this.category.tree = [];
      this.form.data.parentId = null;
      this.getGoodsCategoryList();
    }

  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getGoodsCategory,
    getGoodsCategoryList,
    treeGenerator,
    formatData,
  },
  data() {
    return {
      cascaderProps: [], // 联机属性
      category: {
        data: [],
        tree: [],
        type: [],
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 999,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 220, // 默认生成截图框宽度
        autoCropHeight: 220, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'S3',
        title: '修改图片',
      },
      form: {
        data: {
          name: '',
          nameEn: '',
          coverPath: '',
          code: '',
          isPush: '',
          seriesId: '',
        },
        title: '',
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
          type: [{ required: true, trigger: 'blur' }],
          seriesId: [{ required: true, trigger: 'blur' }],
        },
      },
    };
  },
  async created() {
    await this.getGoodsCategoryList();
  },
};
</script>
